import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate, useParams } from 'libs/router'
import { useTranslation } from 'react-i18next'
import { OpeningHourItem } from 'features/openingHours/types/openingHours.types'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

export const useEditOpeningHourMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: editOpeningHourMutation, isPending: isEditMutationLoading } = useMutation({
		mutationFn: (data: OpeningHourItem) => {
			return axiosPrivate.put(apiRoutes.openingHour(params.id as string), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.openingHours.all })
			useToast({
				type: 'success',
				message: t('Date updated')
			})()
			navigate('/opening-hours')
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		}
	})

	return {
		editOpeningHourMutation,
		isEditMutationLoading
	}
}
